module.exports = __webpack_public_path__ + "img/upload-bg.37c8fa9d.svg";